// extracted by mini-css-extract-plugin
module.exports = {"lista":"Alimentos_lista__2qb9N"};